/** Promotional surfaces share one switch and display window (ISO 8601 in UTC). */
export const DOUBLE_FESTIVAL_CAMPAIGN = {
  id: 'double_festival_2026',
  // Active from release through October 1, 15:59:59.999 UTC (23:59:59.999 Beijing time).
  enabled: true,
  period: [undefined, '2026-10-01T15:59:59.999Z'] as [string?, string?],
};
